// removed by extract-text-webpack-plugin
module.exports = {"nav":"nav","active":"active"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navigation.css
// module id = 405
// module chunks = 0